import React, { useMemo, useState } from 'react';
import { PageContent } from '@core/ui';
import { Table, Button, message, Alert } from 'antd';

import { useFlyexLocations } from '../hooks/use-flyex-locations';
import { useService } from '@core/inversify-react';
import { CreateFromLocationsRepoType, ICreateFromLocationsRepo } from '../repos';

export const FlyexLocationsPage = () => {
  const { data: flyexLocations = [], isFetching, refetch } = useFlyexLocations();
  const [selectedRowKeys, setSelectedRowKeys] = useState<number[]>([]);

  const createFromLocationsRepo = useService<ICreateFromLocationsRepo>(CreateFromLocationsRepoType);

  const rowSelection = useMemo(
    () => ({
      selectedRowKeys,
      onChange: (keys: React.Key[]) => setSelectedRowKeys(keys as number[]),
    }),
    [selectedRowKeys],
  );

  const createBranches = async () => {
    if (!selectedRowKeys.length) return;

    const response = await createFromLocationsRepo.execute(selectedRowKeys);

    if (response.status === 200) {
      message.success('Yeni filial(lar) yaradıldı');
      setSelectedRowKeys([]);
      refetch();
    } else {
      message.error(response.response || 'Filial yaradılmadı');
    }
  };

  return (
    <PageContent $contain>
      <h2>Flyex Filialları</h2>

      <Alert
        style={{ marginBottom: 16 }}
        message={'Yaradılan yeni Flyex filialı qeyri-aktiv və natamam məlumatlarla yaradılacaq. Aktivləşdirmək üçün məlumatları yerinə doldurmaqla aktivləşdirə bilərsiz.'}
        type='info'
        showIcon
      />

      <Table rowKey='id' dataSource={flyexLocations} loading={isFetching} rowSelection={rowSelection} pagination={false} scroll={{ y: '60vh' }}>
        <Table.Column title='Id' dataIndex='id' key='id' width={100} />
        <Table.Column title='Ad' dataIndex='name' key='name' />
        <Table.Column title='Ünvan' dataIndex='address' key='address' />
        <Table.Column title='Cədvəl' dataIndex='scheduleDescription' key='scheduleDescription' />
        <Table.Column
          title='Xəritə'
          dataIndex='mapUrl'
          key='mapUrl'
          render={(val: string) =>
            val ? (
              <a href={val} target='_blank' rel='noreferrer'>
                Xəritədə aç
              </a>
            ) : (
              '-'
            )
          }
        />
      </Table>

      <div style={{ marginTop: 16, display: 'flex', justifyContent: 'flex-end' }}>
        <Button type='primary' onClick={createBranches} disabled={!selectedRowKeys.length}>
          Yeni Filial yarat
        </Button>
      </div>
    </PageContent>
  );
};
